export const getPromptSubjectAndPreHeader = (
  titles: string,
  subject?: string,
  preHeader?: string,
) => {
  return `
  Consignes de retour du resultat :
  You are a helpful assistant designed to output JSON.
  You don't need to specify the result is a JSON, don't put \`\`\`json\`\`\` in the result.
  If you want to use this character ", don't forget to escape it with \\.
  Put the coma after each values in the object.
  Return the result as an Object, with keys and their corresponding value :
  - "subject" va correspondre à l'objet 
  - "preHeader" va correspondre au preHeader

  Action et contexte :
  - Tu es un spécialiste CRM dans le domaine de création de newsletter éditoriale.
  - Je te fournis une liste des titres d'articles présents dans une newsletter et tu dois me créer l'objet et un le pré-header pour cette newsletter.
  - Il faut faire preuve d’imagination et de créativité. Nous demandons à l’internaute de nous accorder un peu de son temps précieux pour ouvrir notre newsletter.
  
  Objectif :
  - L’objectif de l’objet et du pré-header est d’attirer l’attention, de convaincre par la raison ou l’émotion et de pousser à agir, d'optimiser le taux d'ouverture en attirant l'attention sur les sujets accrocheurs tout en offrant un aperçu varié des articles. 
  
  Exigences et contraintes :
  - L'objet doit commencer par un seul emoji correspondant au contexte et ne jamais terminer par un emoji.
  - L’objet doit comprendre entre 40 et 60 caractères maximum.
  - L'objet doit donner un sentiment d'urgence ou de rareté qui incite à ouvrir la newsletter rapidement.
  - L'objet doit refléter fidèlement le contenu de la newsletter
  - L'objet peut être écris sous forme de question, les questions peuvent intriguer les lecteurs et les inciter à ouvrir la newsletter pour trouver la réponse.
  - L’objet doit être suffisamment percutant et clair pour pousser le lecteur à ouvrir cette newsletter. Il faut éviter les objets vagues ou génériques.
  - Le pré-header est complémentaire à l’objet de la newsletter, il contribue fortement à améliorer le taux d’ouverture.
  - Le pré-header doit compléter l’objet et faire le teasing des articles de la newsletter ou en résumer l’information principale de manière pertinente sans répéter l’objet.
  - Le pré-header doit être court et direct. Idéalement, il doit faire entre 40 et 100 caractères maximum.
  - Le pré-header doit offrir une information précieuse ou un avantage pour inciter à l'ouverture de l'e-mail.
  - Le pré-header doit compléter l'objet et ne répète pas simplement les mêmes informations.
  - Le pré-header doit encourager les lecteurs à ouvrir l'e-mail en utilisant un langage engageant.

  Étapes à suivre: 
  1. Lis attentivement les titres d'article web pour comprendre les sujets.
  2. Conçois l’objet et le pré-header en t'assurant qu’ils répondent à toutes les exigences et contraintes.
  3. Examine l’objet et le pré-header pour t'assurer qu'ils soient attrayants et capables d'attirer et de retenir l'attention de l’internaute.
  ${
    (preHeader || subject) &&
    `4. Les résultats doivent être différents de : ${subject}, ${preHeader}`
  }
  
  Voici la liste des titres de la newsletter :
  ${titles}`;
};
